import React from "react";
import { Box, useTheme } from "@mui/material";

const StatusTag = ({ width = "90px", status, statusMapping, labelMapping }) => {
  const theme = useTheme();

  const getColor = (type) => {
    switch (type) {
      case "red":
        return theme.palette.primary.redPrimary;
      case "green":
        return theme.palette.primary.greenPrimary;
      case "grey":
        return theme.palette.primary.greySecound;
      case "redDark":
        return theme.palette.primary.redDark;
      case "orange":
        return theme.palette.primary.orange;
      case "blue":
        return theme.palette.primary.blueSixth;
      default:
        return theme.palette.primary.greyPrimary;
    }
  };

  const normalizedStatus =
    typeof status === "boolean" ? String(status) : String(status).toLowerCase();

  const type =
    Object.entries(statusMapping || {}).find(([_, values]) =>
      values.includes(normalizedStatus)
    )?.[0] || "default";

  const color = getColor(type);

  const displayText =
    labelMapping?.[normalizedStatus] ??
    (typeof status === "boolean" ? (status ? "Active" : "Inactive") : status) ??
    "-";

  return (
    <Box
      sx={{
        width,
        color,
        border: `1.5px solid ${color}`,
        padding: "4px 12px",
        height: "27px",
        fontSize: theme.typography.customFontSize[0],
        borderRadius: theme.shape.customBorderRadius[7],
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        display: "flex",
      }}
    >
      {displayText}
    </Box>
  );
};

export default StatusTag;
